// extracted by mini-css-extract-plugin
export default {"wrapper":"LoaderCentered_wrapper__Ha6ho","color":"LoaderCentered_color__F0uv-"};